/*
 * @Author: edvardchen
 * @Date:   2016-12-12 21:45:19
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-12 21:49:04
 */

export default function shareQS(query = {}) {
  const { sc_id, from } = query;
  return { sc_id, from };
}
